<template>
  <div class="token-part-wrapper content-part-wrapper" id="token">
    <div class="token-title-wrapper content-title-wrapper">
      <h3>{{ $t('TOKEN') }}</h3>
      <span class="title-line"></span>
    </div>
    <div class="token-content">
      <div class="token-content-left">
        <img
          class="token-img"
          src="../../assets/pagetoken/token.png"
          alt="token"
        />
      </div>
      <div class="token-content-right">
        <div class="token-introduce">{{ $t('introduce') }}</div>
        <div class="token-chart">
          <div class="token-each-line">
            <div class="token-use-content token-chart-title">
              <div class="token-each-item"><span>{{ $t('Use') }}</span></div>
              <div class="token-each-item token-span-center"><span>{{ $t('Proportion') }}</span></div>
              <div class="token-each-item"><span>{{ $t('Number') }}</span></div>
              <div class="token-each-item"><span>{{ $t('Memo') }}</span></div>
            </div>
            <div
              class="token-use-content"
              v-for="item in token"
            >
              <div class="token-each-item"><span>{{item.use}}</span></div>
              <div class="token-each-item token-span-center"><span>{{item.proportion}}</span></div>
              <div class="token-each-item"><span>{{item.numbers}}</span></div>
              <div class="token-each-item"><span>{{item.memo}}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<i18n>
{
  "en": {
    "Use": "Use",
    "Proportion": "Proportion",
    "Number": "Number",
    "Memo": "Memo",
    "introduce": " The name of the token BonusCloud plan to issue is BxC. It will be issued a total number of 7 billion BxC, 40% of it will be allocated to the community through award, 20% to the team, 10% as development reserve fund, 30% will be allocated to cornerstone investors and well-known investment institutions through token subscription." ,
    "token": [
        {
          "use": "Institutions and Strategic Partners",
          "proportion": "30%",
          "numbers": "2.1 Billion",
          "memo": "It will be released evenly by quarter in 1 year"
        },
        {
          "use": "Award",
          "proportion": "40%",
          "numbers": "2.8 Billion",
          "memo": "It will be released evenly within 4 years."
        },
        {
          "use": "Founding Team",
          "proportion": "20%",
          "numbers": "1.4 Billion",
          "memo": "It will be released evenly by quarter in 3 years."
        },
        {
          "use": "BonusCloud Foundation and Ecosystem",
          "proportion": "10%",
          "numbers": "0.7 Billion",
          "memo": "It will be released after listing."
        }
      ]
  },
  "zn": {
    "Use": "用途",
    "Proportion": "占比",
    "Number": "数量",
    "Memo": "备注",

    "introduce": "博纳云发布的Token名称为BxC。发行总数为70亿，其中40%将通过奖励发放给社区，团队留有20%，基金会持有10%，30%分配给机构和战略合作伙伴。",
    "token": [
        {
          "use": "机构和战略合作伙伴",
          "proportion": "30%",
          "numbers": "21亿",
          "memo": "将在一年内按季度释放"
        },
        {
          "use": "矿池奖励",
          "proportion": "40%",
          "numbers": "28亿",
          "memo": "将在四年内均匀产出"
        },
        {
          "use": "团队",
          "proportion": "20%",
          "numbers": "14亿",
          "memo": "分三年按季度释放"
        },
        {
          "use": "基金会生态 ",
          "proportion": "10%",
          "numbers": "7亿",
          "memo": "登录交易所后释放"
        }
      ]
  }
}
</i18n>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "PcLogin",
  props: {},
  computed: mapState({
    token() {
      return this.$t('token');
    }
  }),
  methods: {
    ...mapActions([])
  },
  created() {
        this.$i18n.locale = this.isZnWebsite ? "zn" : "en";

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="stylus">
.token-content {
  width: 80%;
  display: flex;
  margin: 0 auto 40px;

  img {
    filter: grayscale(40%);
    display: inline-block;
    width: 100%;
  }

  .token-introduce {
    font-size: 12px;
    // height: 30%;
    text-align: left;
    margin: 0 auto;
    font-size: 13px;
    line-height: 2;
    letter-spacing: 1.3px;
  }

  .token-content-left {
    display: inline-block;
    width: 40%;
  }

  .token-content-right {
    display: inline-block;
    width: 50%;
    margin-left: 40px;
    font-size: 12px;

    .token-introduce {
      // height: 30%;
    }

    .token-chart {
      height: 70%;

      .token-each-line {
        height: 100%;
      }
    }

    .token-use-content {
      display: flex;
      height: 20%;
      border-top: 1px solid #262a3b;

      .token-each-item {
        display: inline-block;
        width: 250px;
      }
    }
  }

  .token-chart {
    height: 70%;
    margin-top: 20px;

    .token-chart-title {
      font-weight: 700;
      font-size: 16px;
    }

    .token-use-content {
      display: flex;
    }

    .token-span-center {
      // text-align: center;
      padding-left: 30px;
      box-sizing: border-box;
    }

    .token-each-item {
      width: 24%;
      position: relative;

      span {
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
      }
    }
  }
}

@media (max-width: 640px) {
  .token-part-wrapper {
    .token-content {
      width: 100%;
      display: block;
    }

    width: 100%;
    height: auto;
    border-radius: 0px;

    .token-content-left {
      display: block !important;
      width: 80% !important;
      margin: 0 auto 20px;
    }

    .token-content-right {
      width: 90%;
      margin-left: 0px;
    }

    .token-chart {
      display: none;
    }

    .token-introduce {
      margin: 10px 10px;
    }
  }
}
</style>
